const isBDActive = () => {
    const getValidDate = date => new Date(date)
    const currentDate = '2026-11-05T10:37';
    const startDate = '2025-06-25T00:00';
    let endDate = '2025-06-25';
    if ('' !== endDate) {
        endDate = '2025-06-25T23:59'
    }

    return getValidDate(startDate) <= getValidDate(currentDate) && getValidDate(currentDate) <= getValidDate(endDate)
}

window.biotech_day_is_active = isBDActive()